import { render } from "./CollectionBlock.vue?vue&type=template&id=68f771aa"
import script from "./CollectionBlock.vue?vue&type=script&lang=js"
export * from "./CollectionBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__